<template>
    <div>
        <transition
            name="fade"
            enter-active-class="transition-all duration-200 ease-in-out transform "
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-all duration-200 ease-out transform "
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <slot></slot>
        </transition>
    </div>
</template>
